import { Routes, Route } from 'react-router-dom';
import pageRegistry from '@/pageRegistry';
import ProtectedRoute from './ProtectedRoute';
import React, { Suspense } from 'react';
import Splash from '../components/splash';

export default function AppRouter() {
  return (
    <Routes>
      {Object.entries(pageRegistry).map(([path, def]) => {
        const Component = React.lazy(def.component);
        const meta = def.meta || {};

        return (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute meta={meta}>
                <Suspense fallback={<Splash />}>
                  <Component />
                </Suspense>
              </ProtectedRoute>
            }
          />
        );
      })}

      <Route path="*" element={<div>Not Found</div>} />
    </Routes>
  );
}
